module.exports = __webpack_public_path__ + "static/media/12x16no3.087d8d91.jpg";